module.exports = __webpack_public_path__ + "static/3invgde-05be48d5c2ff7c8558726b7a5db479f3.gif";